import { useNotification } from '@/hooks';
import {
  useMarkAsLostMutation,
  useMarkAsPreparedMutation,
} from '../services/scheduled-pending.service';
import { NotificationSeverity } from '@/components/notifications/Notification';

const usePreparePackageActions = () => {
  const [markAsLost, { isLoading: isMarkAsLostLoading }] =
    useMarkAsLostMutation();
  const [markAsPrepared, { isLoading: isMarkAsPreparedLoading }] =
    useMarkAsPreparedMutation();

  const { showNotification } = useNotification();

  const onMarkAsLost = async (inboxId: string) => {
    try {
      await markAsLost(inboxId).unwrap();
      showNotification(
        'Pedido marcado como perdido',
        NotificationSeverity.success,
        2000
      );
    } catch (error) {
      console.error(error);
      showNotification(
        'Error al marcar el pedido como perdido',
        NotificationSeverity.error,
        2000
      );
    }
  };

  const onMarkAsPrepared = async (inboxId: string) => {
    try {
      await markAsPrepared(inboxId).unwrap();
      showNotification(
        'Pedido marcado como preparado',
        NotificationSeverity.success,
        2000
      );
    } catch (error) {
      console.error(error);
      showNotification(
        'Error al marcar el pedido como preparado',
        NotificationSeverity.error,
        2000
      );
    }
  };

  return {
    onMarkAsLost,
    onMarkAsPrepared,
    isTagging: isMarkAsLostLoading || isMarkAsPreparedLoading,
  };
};

export default usePreparePackageActions;
